/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEntraSyncFailures200ResponseFailuresInner
 */
export interface GetEntraSyncFailures200ResponseFailuresInner {
    /**
     * 
     */
    clientUUID?: string;
    /**
     * 
     */
    clientName?: string;
    /**
     * 
     */
    usesAdminConsent?: boolean;
    /**
     * 
     */
    retryCount?: number;
    /**
     * 
     */
    errorReason?: string | null;
}

/**
 * Check if a given object implements the GetEntraSyncFailures200ResponseFailuresInner interface.
 */
export function instanceOfGetEntraSyncFailures200ResponseFailuresInner(value: object): value is GetEntraSyncFailures200ResponseFailuresInner {
    return true;
}

export function GetEntraSyncFailures200ResponseFailuresInnerFromJSON(json: any): GetEntraSyncFailures200ResponseFailuresInner {
    return GetEntraSyncFailures200ResponseFailuresInnerFromJSONTyped(json, false);
}

export function GetEntraSyncFailures200ResponseFailuresInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEntraSyncFailures200ResponseFailuresInner {
    if (json == null) {
        return json;
    }
    return {
        
        'clientUUID': json['clientUUID'] == null ? undefined : json['clientUUID'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'usesAdminConsent': json['usesAdminConsent'] == null ? undefined : json['usesAdminConsent'],
        'retryCount': json['retryCount'] == null ? undefined : json['retryCount'],
        'errorReason': json['errorReason'] === undefined ? undefined : json['errorReason'] === null ? null : json['errorReason'],
    };
}

export function GetEntraSyncFailures200ResponseFailuresInnerToJSON(json: any): GetEntraSyncFailures200ResponseFailuresInner {
    return GetEntraSyncFailures200ResponseFailuresInnerToJSONTyped(json, false);
}

export function GetEntraSyncFailures200ResponseFailuresInnerToJSONTyped(value?: GetEntraSyncFailures200ResponseFailuresInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientUUID': value['clientUUID'],
        'clientName': value['clientName'],
        'usesAdminConsent': value['usesAdminConsent'],
        'retryCount': value['retryCount'],
        'errorReason': value['errorReason'],
    };
}

